import { useLazyGetDefaultTemplateQuery } from 'app/features/templates/api';
import React from 'react';
type Props = {
  poItemId: string | number;
  productId: string | number;
  children: (props: any) => React.ReactElement;
};
const WithLoadPOTemplate: React.FC<Props> = (props) => {
  const [fetchDefault, result] = useLazyGetDefaultTemplateQuery();

  //TODO: Temp to comment this one for fetch default template
  React.useEffect(() => {
    fetchDefault(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return props.children({
    template: result?.data
  });
};

export default WithLoadPOTemplate;
